import { render, staticRenderFns } from "./Vheader.vue?vue&type=template&id=34b56366&"
import script from "./Vheader.vue?vue&type=script&lang=js&"
export * from "./Vheader.vue?vue&type=script&lang=js&"
import style0 from "./Vheader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports